// @Core
import { useState } from 'react';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Event Handlers
import { CancelDropModalFooterHandlers } from '../handlers/cancel-drop-modal-footer.handlers';
// Types
import { CancelDropModalModalFooterHookType } from './types/cancel-drop-modal-modal-footer.hook.type';

const useCancelDropModalHook = (): CancelDropModalModalFooterHookType => {
  const [loading, setLoading] = useState<boolean>(false);

  const { setCurrentState } = useAppContextConsumerHook();

  return {
    ...CancelDropModalFooterHandlers({ setLoading, setCurrentState }),
    loading,
  };
};

export { useCancelDropModalHook };
